import React, { useState } from 'react'
import RanchDetailForm from './RanchDetailsForm';
import RanchDetailList from './RanchDetailsList';

const RanchDetail= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <RanchDetailForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <RanchDetailList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default RanchDetail